import React from 'react';
import OrganizationEvents from 'screens/organizations/components/OrganizationEvents';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationEventsScreen = () => <OrganizationEvents />;

export default OrganizationEventsScreen;

OrganizationEventsScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper>{page}</MemberOnlyOrganizationWrapper>
);
